<div class="dialog">
  <h1>Add a Section</h1>
  <div class="add-sections">
    <div class="add-section-item" (click)="addSection('asset')" data-test-id="add-asset-section">
      <app-svg src="/assets/icons/64/image-stack.svg"></app-svg>
      <div class="add-section-item-content">
        <h2>Media</h2>
        <p>Create a media section.</p>
      </div>
      <app-svg src="/assets/icons/plus-circle.svg"></app-svg>
    </div>
    @if (!gallery().section) {
      <div class="add-section-item" (click)="addSection('gallery')" data-test-id="add-album-section">
        <app-svg src="/assets/icons/64/gallery-arrow.svg"></app-svg>
        <div class="add-section-item-content">
          <h2>
            Sub-Gallery
            <app-upgrade-badge
              location="add-section-dialog"
              scope="gallery:sub-gallery"
              [tenantId]="gallery()['tenant']?.['id'] || gallery()['tenant']"
            ></app-upgrade-badge>
          </h2>
          <p>Add multiple galleries.</p>
        </div>
        <app-svg src="/assets/icons/plus-circle.svg"></app-svg>
      </div>
    }
    <div class="add-section-item" (click)="addSection('text')" data-test-id="add-text-section">
      <app-svg src="/assets/icons/64/typed-text.svg"></app-svg>
      <div class="add-section-item-content">
        <h2>Text</h2>
        <p>Add a title and paragraph.</p>
      </div>
      <app-svg src="/assets/icons/plus-circle.svg"></app-svg>
    </div>
    <div class="add-section-item" (click)="addSection('embed')" data-test-id="add-embed-section">
      <app-svg src="/assets/icons/64/embed.svg"></app-svg>
      <div class="add-section-item-content">
        <h2>
          Embed
          <app-upgrade-badge
            scope="gallery:embed-section"
            location="add-section-dialog"
            [tenantId]="gallery()['tenant']?.['id'] || gallery()['tenant']"
          ></app-upgrade-badge>
        </h2>
        <p>Paste an embed code.</p>
      </div>
      <app-svg src="/assets/icons/plus-circle.svg"></app-svg>
    </div>
  </div>
  <div class="bottom-text">
    <div>You can add multiple sections to a gallery.</div>
    <a href="https://help.picflow.com/en/articles/5547765-gallery-sections" class="primary-link" target="_blank"
      >Learn more</a
    >
  </div>
</div>
